// extracted by mini-css-extract-plugin
module.exports = {"field":"I-6wx","field-label":"tMMOh","field-value":"H1cwC"};